/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/clothing': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20.75 16.34c.75.43 1.25 1.24 1.25 2.16a2.5 2.5 0 01-2.5 2.5h-15A2.5 2.5 0 012 18.5c0-.92.5-1.73 1.25-2.16h-.01L11 11.86S11 11 12 10c1 0 2-.9 2-2a2 2 0 10-4 0H8a4 4 0 118 0 4 4 0 01-3 3.87l7.76 4.47h-.01zM4.5 19h15c.17 0 .34-.09.43-.25.14-.25.07-.54-.18-.68L12 13.59l-7.75 4.48c-.25.14-.32.43-.18.68.09.16.26.25.43.25z" _fill="#000" fill-rule="evenodd"/>'
  }
})
